import Vue from 'vue'
import VueRouter from 'vue-router'
import '@/utils/logo-navigation'

Vue.use(VueRouter)

const GuestHome = () => import('@/views/rebuild/GuestHome.vue')
const AuthPage = () => import('@/views/rebuild/AuthPage.vue')
const UserPortal = () => import('@/views/rebuild/UserPortal.vue')
const HelpCenterHost = () => import('@/views/rebuild/HelpCenterHost.vue')
const TransactionAgreement = () => import('@/components/HedgingContractTransactionAgreement.vue')

const routes = [
  {
    path: '/',
    name: 'guest-home',
    component: GuestHome
  },
  {
    path: '/login',
    name: 'login',
    component: AuthPage,
    props: { initialMode: 'login' }
  },
  {
    path: '/register',
    name: 'register',
    component: AuthPage,
    props: { initialMode: 'register' }
  },
  {
    path: '/helpCenter',
    name: 'help-center',
    component: HelpCenterHost
  },
  {
    path: '/transactionAgreement',
    name: 'transactionAgreement',
    component: TransactionAgreement
  },
  {
    path: '/app/notifications/:messageId',
    name: 'notification-detail',
    component: UserPortal
  },
  {
    path: '/app/notifications',
    name: 'notifications',
    component: UserPortal
  },
  {
    path: '/app/robots/detail/:strategyId',
    name: 'strategy-detail',
    component: UserPortal
  },
  {
    path: '/app/earnings/leaderboard',
    name: 'earnings-leaderboard',
    component: UserPortal
  },
  {
    path: '/app/:section?',
    name: 'user-portal',
    component: UserPortal
  },
  {
    path: '/center',
    redirect: '/app/overview'
  },
  {
    path: '/robot',
    redirect: '/app/robots'
  },
  {
    path: '/earnings',
    redirect: '/app/earnings'
  },
  {
    path: '/assets',
    redirect: '/app/assets'
  },
  {
    path: '/bills',
    redirect: '/app/bills'
  },
  {
    path: '/invite-cashback',
    redirect: '/app/invite'
  },
  {
    path: '*',
    redirect: '/'
  }
]

const router = new VueRouter({
  mode: 'hash',
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) return savedPosition
    return { x: 0, y: 0 }
  }
})

router.beforeEach((to, from, next) => {
  const needsLogin = to.path.indexOf('/app/') === 0
  const token = window.localStorage.getItem('token')
  const isPublicEntry = ['guest-home', 'login', 'register'].includes(to.name)

  if (token && isPublicEntry) {
    next('/app/overview')
    return
  }

  if (needsLogin && !token) {
    next({
      path: '/login',
      query: { redirect: to.fullPath }
    })
    return
  }

  next()
})

export default router
